var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":4000,"size":80,"color":"#419be0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }